<template>
  <span
    >A new SCORM has been created
    <b>{{ custom_id }}</b>
  </span>
</template>

<script>
export default {
  props: ["value"],
  metadata: {
    color: "green",
    icon: "mdi-file-check-outline",
    subscription_code: "scorm-completed"
  },
  computed: {
    custom_id() {
      return this.value.event.payload && this.value.event.payload
        ? `${this.value.event.payload.custom_id}`
        : "";
    }
  }
};
</script>
